<template>
  <!-- 媒合中 -->
  <div>
    <!-- 無資料時 -->
    <!-- 老師視角 -->
    <template v-if="!loadingFlag">
      <template v-if="coachType===10 && matchList.length === 0" >
      <div class="page-empty">
        <img src="../../../images/background-img/study-grey.png" alt />
        <h3>目前尚無媒合中的課程</h3>
        <p>
          <a href>教課資訊</a> 填寫完畢後，學生即可搜尋到您。當有人詢問您的課程時，將會以此 Email 通知：
          <span>s93565@stu.stu.tw</span>
        </p>
      </div>
      </template>
    </template>
    <!-- 無資料時 -->
    <!-- 學生視角 -->
    <template v-if="!loadingFlag">
      <template v-if="coachType===20 && matchList.length === 0" >
        <div class="page-empty">
          <img src="../../../images/background-img/study-grey.png" alt />
          <h3>目前尚無媒合中的課程</h3>
          <p>
            目前尚無課程，請點選
            <a href>申請輔導</a>
          </p>
        </div>
      </template>
    </template>
    <!-- 有資料時 -->
    <div class="list media-list">
      <ul>
        <li v-for="(item,index) in matchList">
          <div class="item-content" @click="chechHref('medium-detail-student')">
            <div
              class="item-media list-avatar"
              style="background-image: url(https://randomuser.me/api/portraits/women/60.jpg)"
            ></div>
            <div class="item-inner">
              <div class="item-title-row">
                <div class="item-title">{{ item.courseName }}</div>
              </div>
              <div class="item-subtitle">{{ item.chineseName }}</div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <!--
    <div class="list media-list">
      <ul>
        <li>
          <div class="item-content" @click="checkHref('medium-detail-student')">
            <div
              class="item-media list-avatar"
              style="background-image: url(https://randomuser.me/api/portraits/women/60.jpg)"
            ></div>
            <div class="item-inner">
              <div class="item-title-row">
                <div class="item-title">阿拉伯語 (學生視角)</div>
              </div>
              <div class="item-subtitle">黃子瑜</div>
            </div>
          </div>
        </li>
        <li>
          <div class="item-content">
            <div
              class="item-media list-avatar"
              style="background-image: url(https://randomuser.me/api/portraits/women/90.jpg)"
            ></div>
            <div class="item-inner">
              <div class="item-title-row">
                <div class="item-title">基礎法文</div>
              </div>
              <div class="item-subtitle">董佳佳</div>
            </div>
          </div>
        </li>
        <li>
          <div class="item-content" @click="checkHref('medium-detail-teacher')">
            <div
              class="item-media list-avatar"
              style="background-image: url(https://randomuser.me/api/portraits/women/27.jpg)"
            ></div>
            <div class="item-inner">
              <div class="item-title-row">
                <div class="item-title">法國歷史 (老師視角)</div>
              </div>
              <div class="item-subtitle">陳小美</div>
            </div>
          </div>
        </li>
        <li>
          <div class="item-content">
            <div
              class="item-media list-avatar"
              style="background-image: url(https://randomuser.me/api/portraits/women/51.jpg)"
            ></div>
            <div class="item-inner">
              <div class="item-title-row">
                <div class="item-title">西洋美術史</div>
              </div>
              <div class="item-subtitle">吳婷婷</div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    
-->
  </div>
</template>

<script>
import Service from "../../../service";
import { bus } from '../../../js/bus';
export default {
  components: {},
  data() {
    return {
      dish: Service.getDish(this.$f7route.params.id),
      matchList:[],
      coachType:this.$store.state.coachType,
      loadingFlag:false
    };
  },

  created: function() {
      let self = this;
      bus.$on('mediumBus',function(res) {
        self.loadingFlag = true;
        self.matchList = res.matchList;
        self.loadingFlag = false;
      });
  },
  methods: {
    checkHref: function(linkText) {
      this.$f7router.navigate("/" + linkText);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/academic-counseling/medium/medium-item.vue